import { useEffect, useRef, useState } from 'react';

export default function BrandIntro() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full min-h-[60vh] flex items-center justify-center bg-black overflow-hidden py-16 sm:py-24 md:py-32">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-[#00d4ff]/20 to-transparent"
          style={{ animation: 'slideRight 15s linear infinite' }}
        ></div>
      </div>
      <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-transparent to-[#00d4ff]/5"></div>
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-transparent to-[#00d4ff]/5"></div>

      <div className="relative z-10 w-[90%] max-w-5xl mx-auto text-center space-y-8 sm:space-y-12 md:space-y-16">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extralight text-white leading-tight">
            Motion Makes The World Go Around.
          </h2>
        </div>
        <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-transparent bg-clip-text bg-gradient-to-r from-white via-[#00d4ff] to-white leading-tight">
            In God We Trust Motion Boyz
          </h2>
        </div>
        <div className={`transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#00d4ff] leading-tight"
            style={{ textShadow: '0 0 30px rgba(0, 212, 255, 0.6), 0 0 60px rgba(0, 212, 255, 0.3)' }}
          >
            Live By The Code
          </h2>
        </div>
      </div>

      <style>{`
        @keyframes slideRight { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }
      `}</style>
    </section>
  );
}
